import appAxios from "../../utils/appAxios";
export default {
    namespaced: true,
    state: {
        question: {
            id: new Date().getTime(),
            categoryId: 0,
            questionText: null,
            questionInfoText: null,
            code: null,
            score: 0,
            infoOnly: false,
            answers: [],
            checked: false,
            locales: [],
        },
        questionList: [],
        totalRecords: 0,
        loading: false

    },
    getters: {
        _getQuestions: (state) => { return state.questionList },
        _getTotalRecords: (state) => { return state.totalRecords },
        _getLoading: (state) => { return state.loading }
    },

    mutations: {
        SET_QUESTIONS: (state, Data) => {

            state.questionList = []
            state.totalRecords = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.questionList.push(item)
                });
            }
            state.loading = false
        }
    },

    actions: {
        async GET_QUESTIONS(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Question/Get/${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else (resolve(false))
                })
            })
        },


        async GET_ALL_QUESTIONS({ commit, state }, payload) {
            state.loading = true
            await appAxios.post("/admin/Question/GetAll", payload).then(response => {
                if (response.data.Success) {
                    commit("SET_QUESTIONS", response.data.Data)
                }
            }).catch(() => state.loading = false)
        },

        async ADD_QUESTIONS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Question/Create", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        async DELETE_QUESTIONS({ dispatch }, payload) {
            await appAxios.post("/admin/Question/Delete", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ALL_QUESTIONS", payload[1])
                }
            })

        },

        async UPDATE_QUESTIONS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Question/Update", payload).then(response => {
                    resolve(response.data.Success)
                })
            })

        },

        async QUESTION_COPY(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Question/Copy?id=${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data)
                    }
                })
            })
        }




    }

}